export const IOS_VIEW_URL = 'https://view.adjust.com/impression/11oyucs';
export const IOS_CLICK_URL = 'https://app.adjust.com/11oyucs';
export const ANDROID_VIEW_URL = 'https://view.adjust.com/impression/8slwagc';
export const ANDROID_CLICK_URL = 'https://app.adjust.com/8slwagc';
